export class AerolineaDestinoDTO {
    id:string;
    codigoAeroplanta:string;
    cuenta:string;
    codigoAeropuerto:string;    
}